export const checkStatusEnum = [
  { label: '审核拒绝', value: 0 },
  { label: '审核通过', value: 1 },
  { label: '待审核', value: 2 }
]

export const LOCAL_STORAGE_KEY_AUTH_VIDEO_ITEM = 'auth-video-item'
